import React, { useState, useContext } from "react";

import { useForm } from "react-hook-form";
import { Oval } from "react-loader-spinner";
import { useMediaPredicate } from "react-media-hook";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import { ContextGlobal } from "../contexts/ContextGlobal";

export const Footer = (props) => {
    const { reachOut, activePage } = useContext(ContextGlobal);

    const {
        register,
        handleSubmit,
        reset,
        setError,
        formState: { errors },
    } = useForm({ mode: "onSubmit" });

    const [loading, setLoading] = useState(false);

    const onSubmitEmail = async (data) => {
        // -- Constant Contact Form --
        const emailCC = document.getElementById("email_address_1");
        emailCC.value = data.email;
        document.querySelector("div.ct-footer-form button[className='ctct-form-button']").click();

        setLoading(true);
        data.reachOut = true;
        await reachOut(data);
        reset({
            email: "",
        });
        setLoading(false);
    };

    const midSizeScreen = useMediaPredicate("(max-width: 1080px)");

    if (activePage.portal) {
        return <></>;
    }

    return (
        <footer>
            <img src="./img/bg-footer.png" className="bg-image-bottom-right"/>
            <div className="row transparent">
                <div className="col-md-1"></div>
                <div className="col-md-10 px-4 mt-5">
                    <div className="row">
                        {/* <div className="col-6 col-md-2 mb-3">
                            <h6 style={{ color: '#1db8ea' }}>About Us</h6>
                            <ul className="nav flex-column">
                                <li className="mb-2" style={{ fontSize: "14px" }}><a href="/access/about-us#who" className="p-0 footer-line-item">Who We Are</a></li>
                                <li className="mb-2" style={{ fontSize: "14px" }}><a href="/access/about-us#what" className="p-0 footer-line-item">What We Do</a></li>
                                <li className="mb-2" style={{ fontSize: "14px" }}><a href="/access/about-us#difference" className="p-0 footer-line-item">The Difference</a></li>
                                <li className="mb-2" style={{ fontSize: "14px" }}><a href="/access/about-us#whitepaper" className="p-0 footer-line-item">Whitepapers</a></li>
                                <li className="mb-2" style={{ fontSize: "14px" }}><a href="/access/about-us#experts" className="p-0 footer-line-item">Experts</a></li>
                            </ul>
                        </div> */}
                        <div className="col-12 col-md-8 mb-3">
                            <a className="" href="https://www.accumedintel.com/" rel="noopener noreferrer">
                                <img src="./img/Logo_Default.png" height={!midSizeScreen ? "65vh" : "35vh"} alt="Logo" />
                            </a>
                        </div>
                        <div className="col-6 col-md-2 mb-3">
                            <h4 style={{ color: "#787f8d", fontWeight: '600', fontFamily: 'Montserrat' }}>Products</h4>
                            <ul className="nav flex-column">
                                <li className="mb-2" style={{ fontSize: "14px", color: "#1f2f49", fontWeight: '600', fontFamily: 'Montserrat' }}>
                                    <a href="https://www.accumedintel.com/medical-cost-projections/" className="p-0 footer-line-item" rel="noopener noreferrer" target="_blank">
                                        Medical Cost Projection
                                    </a>
                                </li>
                                <li className="mb-2" style={{ fontSize: "14px", color: "#1f2f49", fontWeight: '600', fontFamily: 'Montserrat' }}>
                                    <a href="https://www.accumedintel.com/bill-analysis/" className="p-0 footer-line-item" rel="noopener noreferrer" target="_blank">
                                        Bill Analysis
                                    </a>
                                </li>
                                <li className="mb-2" style={{ fontSize: "14px", color: "#1f2f49", fontWeight: '600', fontFamily: 'Montserrat' }}>
                                    <a href="https://www.accumedintel.com/expert-support/" className="p-0 footer-line-item" rel="noopener noreferrer" target="_blank">
                                        Expert Support
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="col-6 col-md-2 mb-3">
                            <h4 style={{ color: "#787f8d", fontWeight: '600', fontFamily: 'Montserrat'  }}>Company</h4>
                            <ul className="nav flex-column">
                                <li className="mb-2" style={{ fontSize: "14px", color: "#1f2f49", fontWeight: '600', fontFamily: 'Montserrat'  }}>
                                    <a href="https://www.accumedintel.com/about/" className="p-0 footer-line-item" rel="noopener noreferrer" target="_blank">
                                        About Us
                                    </a>
                                </li>
                                <li className="mb-2" style={{ fontSize: "14px", color: "#1f2f49", fontWeight: '600', fontFamily: 'Montserrat'  }}>
                                    <a href="https://www.accumedintel.com/contact/" className="p-0 footer-line-item" rel="noopener noreferrer" target="_blank">
                                        Contact
                                    </a>
                                </li>
                                {/* <li className="mb-2" style={{ fontSize: "14px", color: "#1f2f49", fontWeight: '600', fontFamily: 'Montserrat'  }}>
                                    <a href="https://www.accumedintel.com/contact/#brxe-oroijm" className="p-0 footer-line-item" rel="noopener noreferrer" target="_blank">
                                        FAQs
                                    </a>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                    <div className="d-flex flex-column flex-sm-row justify-content-between py-4 my-4">
                        <p>© 2024 Copyright: AccuMed HealthCare Research, LLC. All rights reserved.</p>
                    </div>
                </div>
                <div className="col-md-1"></div>
            </div>
            {/* <div className="ctct-inline-form ct-footer-form" style={{ display: "none" }} data-form-id="6d185326-9e24-46e7-9daf-25aab59b11d7"></div> */}
        </footer>
    );
};
